import { render, staticRenderFns } from "./MortgageApplicationApprovalPopup.vue?vue&type=template&id=383aeae9&scoped=true&"
import script from "./MortgageApplicationApprovalPopup.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationApprovalPopup.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationApprovalPopup.vue?vue&type=style&index=0&id=383aeae9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383aeae9",
  null
  
)

export default component.exports